import { useLocation } from 'react-router-dom';
import {
  CatalogIndexPage,
  type DefaultCatalogPageProps,
} from '@backstage/plugin-catalog';

/**
 * Remounts the catalog list when the history entry changes so Kind/Type filters
 * rehydrate from the URL after browser Back/Forward.
 */
export const CatalogIndexPageWithUrlSync = (props: DefaultCatalogPageProps) => {
  const location = useLocation();
  return (
    <CatalogIndexPage
      key={`${location.key}:${location.search}`}
      {...props}
    />
  );
};
